import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { PageHandler } from "../../../library-js/dom-tools/PageHandler";
import { LanguageCode, LanguageCodes } from "../../../library-js/i18n/LanguageCode";
import { MultiString } from "../../../library-js/i18n/MultiString";
import { EmailInput, UserSignUpRequest } from "../../../library-js/php/user/UserSignUpRequest";
import { TemplatesList } from "../../templates/TemplatesList";
import { EmailOverlay } from "../overlay/EmailOverlay";
import { Rokojori } from "../Rokojori";
import { RokojoriUser } from "./RokojoriUser";


export class RequestDeleteOverlay
{
  static readonly attribute = new ElementAttribute( "request-delete" );

  static applyOnDocument()
  {
    RequestDeleteOverlay.attribute.forEachInDoc( e => RequestDeleteOverlay.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {  

    let functionName:MultiString =
    {
      en:"request-account-deletion",
      de:"konto-löschung-anfordern"
    }; 

    PageHandler.setFunctionHandleLink( e, Rokojori.locale( functionName ),
      ()=> 
      { 
        let template = TemplatesList.REQUEST_DELETE_OVERLAY;
        
        let onSend = async ( email:string )=>
        {
          let response = await Rokojori.$._oldPHPUser.requestDelete( email );

          return Promise.resolve( ! response.error )
        }

        EmailOverlay.open( template, onSend, true ); 
      } 
    );
  }


}